
class MenuToggle {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.initToggle();
        this.initcloseDropdownOnMenuToggle();
    }

    initToggle() {

    }


    initcloseDropdownOnMenuToggle() {
        const menuToggle = $(this.elem).siblings('.m-menu-toggle-input');

        if (menuToggle.length){
            $(this.elem).on('click', (e) => {
                $('.o-header__inner-container').find('input')
                    .prop('checked', false);
            });
        }
    }
}

export default MenuToggle;

